import { Link, LinkProps } from 'react-router-dom';
import graphic from '../../../assets/certificates/no-data.svg';
import { Button } from '@mosey/components/buttons/Button';

interface Props {
  title?: string;
  description?: string;
  showBackButton?: boolean;
  backTo?: LinkProps['to'];
}

export const NoDocumentsFoundPanel = ({
  title = 'No documents found',
  description,
  showBackButton = true,
  backTo = '/documents',
}: Props) => (
  <div className="flex grow flex-col items-center justify-center overflow-y-auto">
    <div className="mb-6 flex w-full max-w-2xl justify-center">
      <img src={graphic} alt="" />
    </div>

    <h2 className="mb-1 text-center text-4xl font-bold tracking-tight">
      {title}
    </h2>

    {description && <p className="mb-8 text-zinc-800">{description}</p>}

    {showBackButton && (
      <div className="flex items-center gap-x-4">
        <Button as={Link} size="xlarge" to={backTo}>
          Back to all documents
        </Button>
      </div>
    )}
  </div>
);
